import { ChangeDetectionStrategy, Component, TemplateRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export type InfotextDialogData = {
  text?: string;
  template?: TemplateRef<unknown>;
};

@Component({
  selector: 'ui-infotext-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
  template: `
    <div class="flex justify-between items-center px-6 pt-6 pb-0">
      <span class="text-xl font-semibold">Eingabehilfe</span>
      <button mat-icon-button type="button" (click)="dialogRef.close()">
        <mat-icon svgIcon="cp-close" />
      </button>
    </div>
    <mat-dialog-content class="px-6 pb-6 pt-0">
      @if (data.template) {
        <ng-container [ngTemplateOutlet]="data.template" />
      } @else {
        <p class="text-base m-0" [innerHTML]="data.text"></p>
      }
    </mat-dialog-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfotextDialogComponent {
  protected data = inject<InfotextDialogData>(MAT_DIALOG_DATA);
  protected dialogRef = inject(MatDialogRef);
}
